import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ferris/react';
import cn from 'classnames';
import { Banner, BannerNote } from '@ferris/react/components/banner';
import { BannerType } from '@ferris/react/components/banner/Banner';

export const ErrorBanner = (props) => {
    const {
        hide,
        text,
        classNames
    } = props;

    if (hide) return null;

    const classes = cn('cl-alert-banner', ...classNames);
    return (
        <Banner
            type={BannerType.ERROR}
            scope="content"
            stacked
            icon={(
                <Icon
                    name="error"
                    color="reversed"
                    size="medium"
                />
            )}
            classes={classes}
        >
            <BannerNote>
                <p>{text}</p>
            </BannerNote>
        </Banner>
    );
};

ErrorBanner.propTypes = {
    text: PropTypes.string.isRequired,
    hide: PropTypes.bool,
    classNames: PropTypes.arrayOf(PropTypes.string)
};

ErrorBanner.defaultProps = {
    hide: true,
    classNames: []
};

export default ErrorBanner;
